import { PokerRunEvent } from "@models/PokerRunEvent";
import { EventParticipant } from "@models/EventParticipant";
import { Stop } from "@models/Stop";
import useDate from "@/modules/useDate";
const { formatISODatetime } = useDate();

export default class EventParticipantContainer {
  eventParticipants: EventParticipant[];

  constructor(eventParticipants: EventParticipant[]) {
    this.eventParticipants = [...eventParticipants];
  }

  getMaxCardsDealt(): number {
    return this.eventParticipants.reduce(
      (a, b) =>
        a > (b.hand?.cardSlots.filter((x) => x.show).length ?? 0)
          ? a
          : b.hand?.cardSlots.filter((x) => x.show).length ?? 0,
      0
    );
  }

  hasExtraCard(): boolean {
    return (
      this.eventParticipants.find((x) => x.hand?.cardSlots?.find((y) => y.isExtra)) !== undefined
    );
  }

  checkIn(
    checkinCode: string,
    pokerRunEvent: PokerRunEvent,
    stop: Stop,
    checkinMetadata: any
  ): void {
    const data = checkinMetadata
      ? { ...checkinMetadata, checkinDateTime: formatISODatetime(new Date()), stop: stop.order }
      : { checkinDateTime: formatISODatetime(new Date()), stop: stop.order };
      if (pokerRunEvent.eventSettings.cardReleaseStyle === undefined) {
        pokerRunEvent.eventSettings.cardReleaseStyle = "relaxed";
      }
    this.eventParticipants.forEach((currentEventParticipant) => {
      let cardIndex = 0;
      currentEventParticipant.stops.forEach((s) => {
        const cardsPerStop = pokerRunEvent.stops.find((x) => x.order === s.order)?.cardsPerStop;
        if (!cardsPerStop) {
          throw "Cards per stop is missing";
        }
        
        // Skip stops that shouldn't be checked in
        if (!s.checkedIn && s.order !== stop.order) {
          // For scheduled release type with relaxed style, only check in current and previous stops
          if (pokerRunEvent.eventSettings.cardReleaseType === "schedule") {
            if (pokerRunEvent.eventSettings.cardReleaseStyle === "relaxed" && s.order > stop.order) {
              return; // Skip future stops
            }
          } else if (pokerRunEvent.eventSettings.cardReleaseStyle !== "relaxed" || s.order > stop.order) {
            return; // Skip for other release types/styles
          }
        }
        
        if (!s.checkedIn) {
          s.checkedIn = true;
          s.checkInMetadata = {
            ...data,
            checkinOrder: s.order,
          };
        }
        if (!currentEventParticipant.hand || !currentEventParticipant.hand.cardSlots) {
          throw "Participant hand is missing";
        }
        for (let i = 0; i < cardsPerStop; i++) {
          if (cardIndex < currentEventParticipant.hand.cardSlots.length) {
            currentEventParticipant.hand.cardSlots[cardIndex].show = true;
            cardIndex++;
          }
        }
      });
      if (!currentEventParticipant.hand || !currentEventParticipant.hand.cardSlots) {
        throw "Participant hand is missing";
      }
      const nCheckedIn = currentEventParticipant.stops.filter((s) => s.checkedIn).length;
      if (currentEventParticipant.extraCard && nCheckedIn >= 2) {
        currentEventParticipant.hand.cardSlots[cardIndex].show = true;
        cardIndex++;
      }
      // eslint-disable-next-line no-param-reassign
      currentEventParticipant.checkedIn = true;
    });
  }
}
